import { useEffect, useRef, useState } from 'react'
import { MediaContext } from '../../utils/use-media-context'
import { ScrollContext } from '../../utils/use-scroll-context'

const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [scrollTop, setScrollTop] = useState(0)
  const [isLockedScroll, setIsLockedScroll] = useState(false)
  const [isMobile, setMediaState] = useState(false)
  const [initialRender, setInitialRender] = useState(true)

  const scrollElement = useRef<any>(null!)
  const htmlElement = useRef<HTMLElement>(null!)
  const bodyElement = useRef<HTMLElement>(null!)

  const checkMediaState = () => {
    setMediaState(window.matchMedia('(max-width: 767px)').matches)
  }

  const onScroll = () => {
    setScrollTop(scrollElement.current.scrollTop)
  }

  const disableScroll = () => {
    document.removeEventListener('scroll', onScroll)
    lockedScroll()
  }

  const lockedScroll = () => {
    htmlElement.current.style.marginTop = `-${scrollTop}px`
    bodyElement.current.style.height = `${scrollTop + htmlElement.current.clientHeight}px`
    htmlElement.current.style.overflow = 'hidden'
    bodyElement.current.style.overflow = 'hidden'
  }

  const unlockedScroll = () => {
    htmlElement.current.style.marginTop = ''
    htmlElement.current.style.overflow = ''
    bodyElement.current.style.height = ''
    bodyElement.current.style.overflow = ''

    if (!initialRender) {
      scrollElement.current.scrollTop = scrollTop
    }

    setTimeout(() => {
      document.addEventListener('scroll', onScroll)
    }, 100)
  }

  useEffect(() => {
    checkMediaState()
    scrollElement.current = document.scrollingElement || document.documentElement || document.body
    htmlElement.current = document.documentElement
    bodyElement.current = document.body

    document.addEventListener('scroll', onScroll)
    window.addEventListener('resize', checkMediaState)

    setInitialRender(false)

    return () => {
      window.removeEventListener('resize', checkMediaState)
    }
  }, [])

  useEffect(() => {
    if (isLockedScroll) disableScroll()
    else unlockedScroll()

    return () => {
      document.removeEventListener('scroll', onScroll)
    }
  }, [isLockedScroll])

  return (
    <ScrollContext.Provider value={{ scrollTop, isLockedScroll, setIsLockedScroll }}>
      <MediaContext.Provider value={{ isMobile }}>{children}</MediaContext.Provider>
    </ScrollContext.Provider>
  )
}

export default LayoutProvider
